// Spec 1.5. The "$" selected chip position is not drawn anywhere -- mirrored from "%" rather than
// invented. `#EEF3EC` has no brand.* token; every variant is a whole literal string, never
// interpolated (`bg-[${x}]` generates no Tailwind rule at all).
const PILL_CLS = 'relative w-[53px] h-[26px] rounded-[6px] bg-[#EEF3EC] hover:bg-[#DDE9D8]'
const CHIP_BASE = 'absolute top-[1px] w-[27px] h-[24px] rounded-[5px] bg-white transition-[left]'
const CHIP_SHADOW = { boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }
const LABEL_BASE = 'relative z-10 text-[13px] font-semibold w-[26px] text-center leading-[24px]'

// "Active"/"inactive" in the spec name the SELECTED state, not a fixed colour per glyph: the
// selected label is always green, the unselected one always dark, regardless of which side.
export default function PercentDollarToggle({ mode, onChange, ariaLabel }) {
  const isDollar = mode === 'dollar'

  return (
    <div className={PILL_CLS} role="radiogroup" aria-label={ariaLabel}>
      <div
        className={CHIP_BASE}
        style={{ ...CHIP_SHADOW, left: isDollar ? '25px' : '1px' }}
      />
      <div className="relative flex h-full">
        <button
          type="button"
          role="radio"
          tabIndex={-1}
          aria-checked={!isDollar}
          onClick={() => onChange('percent')}
          className={`${LABEL_BASE} ${!isDollar ? 'text-brand-green' : 'text-brand-dark'}`}
        >
          %
        </button>
        <button
          type="button"
          role="radio"
          tabIndex={-1}
          aria-checked={isDollar}
          onClick={() => onChange('dollar')}
          className={`${LABEL_BASE} ${isDollar ? 'text-brand-green' : 'text-brand-dark'}`}
        >
          $
        </button>
      </div>
    </div>
  )
}
